module.exports = fox => {
	'use strict';

	return {
		getShortUid() {
			let _udid = _exoUid => {
				return _exoUid.split('|')[1];
			};
			
			if (!fox.exodentity || !fox.exodentity._included || !fox.exodentity.getSavedUid()) {
				return fox.site.wait(fox.site, 'exodentity_fingerprint_recieved', {prefix: 'root_exodentity'})
					.then(data => {
						return _udid(data.params.fingerprint);
					});
			}
	
			return fox.Promise.resolve(_udid(fox.exodentity.getSavedUid()));
		}
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/verification-form/exo-udid.es.js